const key = 'SOCKET_';

exports.SOCKET_UPDATE_VEHICLE = `${key}UPDATE_VEHICLE`;
exports.SOCKET_UPDATE_ALL_VEHICLES = `${key}UPDATE_ALL_VEHICLES`;
